import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'shared/shared.module';
import { GrouperDialogComponent } from './grouper-dialog.component';

@NgModule({
  declarations: [
    GrouperDialogComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
  ],
  exports: [
    GrouperDialogComponent,
  ],
})
export class GrouperDialogModule {
}
